import { useEffect, useState } from "react";
import { Trophy, Medal, Award } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

function rankIcon(rank) {
  if (rank === 1) return <Trophy className="h-5 w-5 text-gcgold" />;
  if (rank === 2) return <Medal className="h-5 w-5 text-slate-400" />;
  if (rank === 3) return <Award className="h-5 w-5 text-amber-700" />;
  return <span className="font-mono text-sm text-slate-500 w-5 text-center font-bold">{rank}</span>;
}

export default function Leaderboard() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/leaderboard").then((r) => setRows(r.data)).catch(console.error); }, []);

  return (
    <div className="min-h-screen bg-ink relative">
      <SEO title="Ranking" path="/ranking" />
      <div className="fixed inset-0 bg-aurora pointer-events-none" />
      <div className="relative">
        <Header />
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-gcgold mb-3 font-mono">Ranking</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tighter leading-[0.95]">
            Mejores opositores
          </h1>
          <p className="mt-3 text-base text-slate-400">Clasificación por nota media. Realiza tests para subir.</p>

          <div className="mt-10 bg-ink-800 border border-white/5 rounded-2xl overflow-hidden">
            <div className="grid grid-cols-[60px_1fr_100px_100px] gap-2 px-5 py-3 border-b border-white/5 bg-white/[0.02] text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500 font-mono">
              <div>Pos</div>
              <div>Opositor</div>
              <div className="text-right">Tests</div>
              <div className="text-right">Media</div>
            </div>
            <div className="divide-y divide-white/5" data-testid="leaderboard-rows">
              {rows.length === 0 && <div className="p-6 text-sm text-slate-500">Aún no hay datos suficientes.</div>}
              {rows.map((r) => {
                const me = user?.id === r.user_id;
                return (
                  <div key={r.user_id} className={`grid grid-cols-[60px_1fr_100px_100px] gap-2 px-5 py-4 items-center transition-colors ${me ? "bg-gcgold/10" : "hover:bg-white/[0.02]"}`}>
                    <div className="flex items-center">{rankIcon(r.rank)}</div>
                    <div className="text-sm font-medium text-white flex items-center gap-2">
                      {r.name}
                      {me && <span className="text-[9px] uppercase tracking-[0.22em] font-mono font-bold text-gcgold bg-gcgold/15 px-1.5 py-0.5 rounded">Tú</span>}
                    </div>
                    <div className="text-right font-mono text-sm text-slate-400">{r.tests}</div>
                    <div className="text-right font-display text-xl font-extrabold text-gcgold tracking-tighter">{r.avg_score}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
